import { Box, useComputedColorScheme } from "@mantine/core";

import imgPurple from "./assets/built-with-blockdaemon-purple.svg";
import imgWhite from "./assets/built-with-blockdaemon-white.svg";

export interface BuiltWithBlockdaemonProps {
  width?: number | string;
  margin?: string;
  alt?: string;
}

export function BuiltWithBlockdaemon({
  width = 175,
  margin = "0 auto",
  alt = "Built with Blockdaemon",
}: BuiltWithBlockdaemonProps) {
  const colorScheme = useComputedColorScheme("light");
  const imgSrc = colorScheme === "dark" ? imgWhite : imgPurple;

  return (
    <Box
      component="img"
      src={imgSrc}
      alt={alt}
      w={width}
      m={margin}
      style={{
        opacity: 0.8,
        transition: "opacity 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = "0.8";
      }}
    />
  );
}
